export const GENERAL = {
  inDev: 'En cours de développement',
  labelObligatoire: '(Obligatoire)',
  btnAnnuler: 'Annuler',
  btnValider: 'Valider',
  btnAjouter: 'Ajouter',
  btnContinuer: 'Continuer',
  btnStreetView: 'Street view',
  btnMap: 'Map',
  Text1DeLaDropdownImage: 'Déposez votre',
  Text2DeLaDropdownImage: 'image ici',
  msgErrorDropdown: 'Vous devez sélectionner une image au format jpg, jpeg ou png',
  msgErrorAutoCompleteGmap: 'Pas de données géographique pour l\'adresse: {name}',
  msgErrorChampObligatoire: 'Vous devez renseigner les champs obligatoires',
  msgConfValidationRecom: "Votre recommandation a été correctement transférée dans la gestion commerciale",
  btnAppliquer: 'Appliquer',
  aucun: 'Aucun',
  msgLienCopie: 'Lien copié',
  msgLienNonCopie: 'Problème lors de la copie du lien',
  problemOccurred: 'Un problème est survenu',
  perPageResult: 'Résultat par page :',
  periodeDuAu: 'Du {debut} au {fin}',
  modalCropper: {
    title: 'Redimensionner votre image',
    preview: 'Prévisualisation',
    btnAnnuler: 'Annuler',
    btnAppliquer: 'Appliquer'
  },
  placeolderSearch: 'Recherche...',
  tous: 'Tous',
  actionGroupe: {
    placeholder: 'Actions groupées',
    options: {
      supprimer: 'Supprimer'
    },
    actionApplication: 'Appliquer'
  },
  btnRetour: 'Retour',
  btnFermer: 'Fermer',
  quantity: {
    day: 'Jour',
    week: 'Semaine',
    month: 'Mois',
    year: 'Année',
    unity: 'Unité',
  },
  societe: {
    titleModal: 'Sélection société',
    placeholder: 'Selectionnez une société',
    msgInfo: 'Le choix de la société est obligatoire.',
    title: 'Société',
  },
  autocomplete: {
    noRslt: 'Aucun résultat',
    search: 'Recherche...',
  },
  validation: {
    internalError: 'Erreur interne',
  },
  messages: {
    warning: {
      archive: 'Élément archivé',
    },
    error: {
      errorTypeFile: 'Ce type de fichier n\'est pas accepté',
      errorSizeFile: 'Ajout impossible de {fileName}. La taille du fichier doit être inférieure < à {maxSize}Mo'
    }
  },
  renouvellement: 'Renouvellement',
  devis: 'Devis',
};
